import React from "react";
import ReactDOM from "react-dom/client";
import "./utils/i18n/index";
import "./index.css";
import App from "./App";
import reportWebVitals from "./configs/reportWebVitals";
import { ThemeProvider } from "./components/theme-provider";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
